/* unplugin-vue-components disabled */import { render } from "./BannerSettingView.vue?vue&type=template&id=503cd922&scoped=true"
import script from "./BannerSettingView.vue?vue&type=script&lang=js"
export * from "./BannerSettingView.vue?vue&type=script&lang=js"

import "./BannerSettingView.vue?vue&type=style&index=0&id=503cd922&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503cd922"]])

export default __exports__